import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'MANUTENCAO_ITEM_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('manutencaoItemForm', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/manutencaoItem`);
    return {
        type: 'MANUTENCAO_ITEM_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/manutencaoItem`, {
                ...registro,
                id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
                dispatch(getListaSugestao());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/manutencaoItem`, {
                ...registro,
                id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
                dispatch(getListaSugestao());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/manutencaoItem?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
            dispatch(getListaSugestao());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaVeiculo() {
    const request = axios.get(`${consts.API_URL}/veiculo/listarSelect`);
    return {
        type: 'MANUTENCAO_ITEM_VEICULO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaManutencaoArea() {
    const request = axios.get(`${consts.API_URL}/manutencaoArea/listarSelect`);
    return {
        type: 'MANUTENCAO_ITEM_AREA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaUnidade() {
    const request = axios.get(`${consts.API_URL}/unidade/listarSelect`);
    return {
        type: 'MANUTENCAO_ITEM_UNIDADE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaSugestao() {
    const request = axios.get(`${consts.API_URL}/manutencaoItem/sugestao`);
    return {
        type: 'MANUTENCAO_ITEM_SUGESTAO_LISTADO',
        payload: request
    };
}
